// import { isMobile } from "./isMobile";

/*
 * Fixed position header
 * ----------------------------------------------- */
jQuery(window).on("load scroll", function () {
  // if (isMobile()) {
  //   return false;
  // }

  var $jsHeader = $(".js-header");

  $jsHeader.each(function () {
    var scroll = $(window).scrollTop();

    if (scroll > 20) {
      $jsHeader.addClass("is-scrolled");
    } else {
      $jsHeader.removeClass("is-scrolled");
    }
  });
});
